// @TODO: scale this to accept more than 1 file
import * as Azure from "@azure/storage-blob";
import { date } from 'quasar'

export default function azureUpload(files, config) {

    const file = files.reduce(item => item)

    const account = config.account;
    const accountSas = config.sas

    const timeStamp = new Date();
    const formattedString = date.formatDate(timeStamp, "YYYY-MM-DDTHH-mm-ss");

    // Use AnonymousCredential when url already includes a SAS signature
    const anonymousCredential = new Azure.AnonymousCredential();

    // List containers
    const blobServiceClient = new Azure.BlobServiceClient(
        // When using AnonymousCredential, following url should include a valid SAS or support public access
        `https://${account}.blob.core.windows.net${accountSas}`,
        anonymousCredential
    );

    // Create a container
    const containerClient = blobServiceClient.getContainerClient(config.containerName);

    // Create a blob
    return new Promise((resolve, reject) => {

        const blobName = config.path + '/' + formattedString + '-' + file.name;
        const blockBlobClient = containerClient.getBlockBlobClient(blobName);
        
        blockBlobClient
            .upload(file, Buffer.byteLength(file))
            .then(resp => {
                console.log(`Upload block blob ${blobName} successful`, resp._response.request.url);
                resolve({
                    url: resp._response.request.url,
                    blobName: config.containerName + '/' + blockBlobClient.name,
                    filename: file.name
                })
            })

    })

}
